"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var useActionForbidden_1 = require("../../../hooks/useActionForbidden");
var PlanItem = function (_a) {
    var plan = _a.plan, onSubscibe = _a.onSubscibe;
    var t = react_i18next_1.useTranslation('common').t;
    var connditionalSubscribe = useActionForbidden_1.useActionForbidden(function () {
        onSubscibe(plan);
    });
    return (react_1.default.createElement("div", { className: classnames_1.default('plan', "plan-" + plan.name) },
        react_1.default.createElement("div", { className: "plan-card" },
            react_1.default.createElement("div", { className: "plan-header" },
                react_1.default.createElement("span", { className: "arrow-help-right" }),
                react_1.default.createElement("div", { className: "icon" },
                    react_1.default.createElement("img", { src: "../../../images/" + plan.icon, className: "icon-buildings" })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: "title" }, plan.label),
                    react_1.default.createElement("p", { className: "description" }, plan.description))),
            react_1.default.createElement("div", { className: "plan-content" },
                plan.content && (react_1.default.createElement("p", { className: "content-info", dangerouslySetInnerHTML: {
                        __html: plan.content,
                    } })),
                plan.services.length > 0 && (react_1.default.createElement("ul", { className: "check-list" }, plan.services.map(function (service, index) {
                    return (react_1.default.createElement("li", { key: index },
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-logo-mini" }),
                        service.title));
                }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("button", { className: "btn btn-secondary activate-sub-plans", onClick: function () { return connditionalSubscribe(); } }, t('subscription.CONTINUE')),
                    react_1.default.createElement("a", { href: "tel:" + GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER, className: "btn btn-outline-primary" }, t('subscription.CALL')))))));
};
exports.default = PlanItem;
